const getters = {
    token: state => state.user.token,
    realname: state => state.user.realname,
    avatar_url: state => state.user.avatar_url,
    userInfo: state => state.user.userInfo,
    domain: state => state.tougao.domain,
    tougaoInfo: state => state.tougao.tougaoInfo,
    tougaoSetting: state => state.tougao.tougaoSetting,
    memberSetting: state => state.tougao.memberSetting,
    memberSettingEn: state => state.tougao.memberSettingEn,
    zuopinSetting: state => state.tougao.zuopinSetting,
    zuopinSettingEn: state => state.tougao.zuopinSettingEn,
    bannerList: state => state.tougao.bannerList,
    categoryList: state => state.tougao.categoryList,
    categoryListEn: state => state.tougao.categoryListEn,
    tid: state => state.tougao.tid,
    language: state => state.app.language
}
export default getters
